exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageContent[data-v-d73a2030] {\n  max-width: 764px;\n}\n.equipment-section[data-v-d73a2030] {\n  padding: 4rem;\n}\n@media (max-width: 768px) {\n.equipment-section[data-v-d73a2030] {\n      padding: 4rem 2rem;\n}\n}\n.productSectionTitle[data-v-d73a2030] {\n  margin-bottom: 4rem;\n}\n", ""]);

// exports
